<style>
</style>

<template>
    <div class="animated fadeIn">
        <b-tabs fill>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-code mr-2"></i>{{Core.Definition.getDefinition('Styles CSS')}}
                </template>
                <DynamicForm
                        class="mt-3"
                        ref="event"
                        @onRequestSuccess="onRequestSuccess"
                        getRoot="/setting/integrations-css"
                        saveRoot="/setting/integrations-css"
                        :formStructure="dataFormStructures.styleCss">
                </DynamicForm>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import DynamicForm from '../../../components/DynamicForm'
    export default {
        name: 'SettingsIntegrations',
        components: {
            DynamicForm
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataFormStructures: {
                    styleCss: {
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'css'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'css',
                                type: Core.Value.typeLongText,
                                label: Core.Definition.getDefinition('Appliquez les styles CSS sur vos widgets. Ces styles seront injectés avec vos widgets sur votre site internet.'),
                                value: ''
                            }
                        ]
                    }
                }
            }
        },
        computed: {
        },
        methods: {
            onRequestSuccess(data) {
            }
        }
    }
</script>
